module.exports = __webpack_public_path__ + "img/icon_official.cc009ed1.svg";